import { render, staticRenderFns } from "./wf-checkbox-list-edit.vue?vue&type=template&id=41a97a90&scoped=true&"
import script from "./wf-checkbox-list-edit.vue?vue&type=script&lang=ts&"
export * from "./wf-checkbox-list-edit.vue?vue&type=script&lang=ts&"
import style0 from "./wf-checkbox-list-edit.vue?vue&type=style&index=0&id=41a97a90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a97a90",
  null
  
)

export default component.exports